var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "json-cell",
      class: [
        _vm.field.alignment,
        {
          "invalid-value": _vm.invalidValue,
          outlined: _vm.outlined,
          readonly: _vm.readonly,
        },
      ],
      on: {
        mouseenter: function ($event) {
          _vm.showOverlay = true
        },
        mouseleave: function ($event) {
          _vm.showOverlay = false
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "json-chip", class: { "has-json": _vm.hasJsonValue } },
        [
          _vm.hasJsonValue
            ? _c("span", [_vm._v(_vm._s(_vm.$t("table.hasJson")))])
            : _c("span", [_vm._v(_vm._s(_vm.$t("table.noJson")))]),
        ]
      ),
      _vm._v(" "),
      _vm.showOverlay && !_vm.readonly
        ? _c(
            "div",
            { staticClass: "overlay-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("a-button", {
                    staticStyle: { "margin-right": "4px" },
                    attrs: { icon: "edit", size: "small" },
                    on: { click: _vm.openJsonEditor },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("a-button", {
                    staticStyle: { "margin-right": "4px" },
                    attrs: { icon: "delete", type: "danger", size: "small" },
                    on: { click: _vm.deleteValue },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showJsonEditorModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("tables.jsonEditorTitle"),
                showFooter: true,
                okText: _vm.$t("message.save"),
                cancelText: _vm.$t("message.cancel"),
                xlarge: "",
              },
              on: { cancel: _vm.closeJsonEditor, ok: _vm.saveJsonValue },
            },
            [
              _c(
                "div",
                { staticClass: "json-editor-container" },
                [
                  _c("v-jsoneditor", {
                    attrs: { options: _vm.jsonEditorOptions, height: "400px" },
                    on: { error: _vm.onJsonError },
                    model: {
                      value: _vm.editingValue,
                      callback: function ($$v) {
                        _vm.editingValue = $$v
                      },
                      expression: "editingValue",
                    },
                  }),
                  _vm._v(" "),
                  _vm.jsonError
                    ? _c("div", { staticClass: "json-error" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.jsonError) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }